import { RawIsland } from '../types';

export const parseRawIslands = (islands: string): Array<RawIsland> => {
	let newIslands = [];
	if (typeof islands === 'string') {
		let tmpIslands = islands
			.replace(/\\/gu, '')
			.replace(/"""/gu, '')
			.replace(/^"/u, '')
			.replace(/"$/u, '');

		if (tmpIslands.substring(0, 1) === '"') {
			tmpIslands = tmpIslands
				.replace(/^"/u, '')
				.replace(/"$/u, '');
		}

		newIslands = JSON.parse(tmpIslands);
	} else {
		newIslands = islands;
	}

	return newIslands;
};
